module.exports = __webpack_public_path__ + "img/ic24Tele.ae7e0fab.svg";